export type ContentType = '文章' | '视频' | '音频' | '指南' | '病例'
export type ContentStatus = '已发布' | '审核中' | '草稿' | '已过期'
export type MeetingStatus = '报名中' | '已报名' | '直播中'

export interface ContentItem {
  id: string
  type: ContentType
  title: string
  summary: string
  therapy: string
  date: string
  readTime: string
  progress?: number
  status?: ContentStatus
  views?: number
  likes: number
  visibility?: 'P' | 'NP' | 'P/NP'
  version?: string
  approvalNumber: string
  expiresAt?: string
  imageTone: 'blue' | 'purple' | 'cyan' | 'navy'
  cover: string
}

export interface MeetingItem {
  id: string
  title: string
  therapy: string
  summary: string
  date: string
  time: string
  location: string
  format: '线上' | '线下' | '混合'
  status: MeetingStatus
  registered: number
  attended?: number
  agenda: Array<{ time: string; title: string; speaker: string }>
}

export const contents: ContentItem[] = [
  {
    id: 'adc-frontier',
    type: '文章',
    title: 'ADC 前沿进展：实体瘤精准治疗',
    summary: '探索最新临床数据与实践洞察，聚焦患者分层、治疗路径及安全性管理。',
    therapy: '乳腺癌',
    date: '2026-08-15',
    readTime: '5 分钟阅读',
    status: '已发布',
    views: 12684,
    likes: 2386,
    visibility: 'P/NP',
    version: 'v2.1',
    approvalNumber: 'M-CN-00005231',
    expiresAt: '2027-02-28',
    imageTone: 'purple',
    cover: '/content-covers/adc-frontier-v2.webp',
  },
  {
    id: 'nccn-lung',
    type: '指南',
    title: 'NCCN 肺癌临床实践指南更新',
    summary: '新证据与指南更新要点，聚焦分期、治疗路径和临床应用原则。',
    therapy: '肺癌',
    date: '2026-08-12',
    readTime: '8 分钟阅读',
    progress: 64,
    status: '已发布',
    views: 9842,
    likes: 1864,
    visibility: 'P',
    version: 'v3.0',
    approvalNumber: 'M-CN-00005208',
    expiresAt: '2027-06-30',
    imageTone: 'blue',
    cover: '/content-covers/nccn-lung-v2.webp',
  },
  {
    id: 'esmo-breast',
    type: '视频',
    title: 'ESMO 乳腺癌研究亮点速览',
    summary: '回顾大会重要研究，涵盖新药、ADC 与免疫联合治疗前沿数据。',
    therapy: '乳腺癌',
    date: '2026-08-10',
    readTime: '12 分钟视频',
    progress: 28,
    status: '已发布',
    views: 8621,
    likes: 1542,
    visibility: 'P/NP',
    version: 'v1.4',
    approvalNumber: 'M-CN-00005196',
    expiresAt: '2027-01-31',
    imageTone: 'cyan',
    cover: '/content-covers/esmo-breast-v2.webp',
  },
  {
    id: 'case-review',
    type: '病例',
    title: 'HER2 低表达病例多学科讨论',
    summary: '从真实诊疗路径出发，讨论治疗选择与跨学科协作中的关键决策。',
    therapy: '乳腺癌',
    date: '2026-08-08',
    readTime: '10 分钟阅读',
    status: '审核中',
    views: 7532,
    likes: 923,
    visibility: 'NP',
    version: 'v0.8',
    approvalNumber: 'M-CN-00005172',
    expiresAt: '2026-12-31',
    imageTone: 'navy',
    cover: '/content-covers/case-review-v2.webp',
  },
  {
    id: 'patient-communication',
    type: '音频',
    title: '医患沟通中的风险说明与共同决策',
    summary: '以真实沟通场景为线索，梳理知情沟通、风险表达与共同决策的实践要点。',
    therapy: '临床实践',
    date: '2026-08-06',
    readTime: '18 分钟音频',
    progress: 42,
    status: '已发布',
    views: 6248,
    likes: 768,
    visibility: 'P',
    version: 'v1.0',
    approvalNumber: 'M-CN-00005153',
    expiresAt: '2027-08-06',
    imageTone: 'blue',
    cover: '/content-covers/patient-communication-v2.webp',
  },
  {
    id: 'adc-safety',
    type: '文章',
    title: 'ADC 治疗安全性管理实践要点',
    summary: '聚焦不良反应识别、分级处置与患者沟通，提供结构化实践参考。',
    therapy: '乳腺癌',
    date: '2026-08-03',
    readTime: '7 分钟阅读',
    status: '已发布',
    views: 5981,
    likes: 1106,
    visibility: 'P/NP',
    version: 'v1.2',
    approvalNumber: 'M-CN-00005129',
    expiresAt: '2027-03-31',
    imageTone: 'cyan',
    cover: '/content-covers/adc-safety-v2.webp',
  },
]

export const meetings: MeetingItem[] = [
  {
    id: 'adc-summit',
    title: 'ADC 治疗进展与临床实践研讨会',
    therapy: '乳腺癌',
    summary: '聚焦 ADC 治疗领域最新循证证据与真实临床实践，分享患者分层、安全性管理和多学科协作经验。',
    date: '2026-08-28',
    time: '13:30–16:30',
    location: '上海浦东嘉里大酒店 / 在线直播',
    format: '混合',
    status: '已报名',
    registered: 842,
    agenda: [
      { time: '13:30', title: '开场与会议介绍', speaker: '大会主席' },
      { time: '13:45', title: 'ADC 治疗格局与关键研究解读', speaker: '陈教授 · 上海' },
      { time: '14:35', title: '真实世界病例讨论', speaker: '李教授 · 北京' },
      { time: '15:25', title: '多学科圆桌讨论与答疑', speaker: 'MDT 专家组' },
    ],
  },
  {
    id: 'oncology-live',
    title: '肿瘤精准治疗临床实践在线研讨会',
    therapy: '肿瘤精准治疗',
    summary: '围绕生物标志物检测、精准分层和治疗决策展开专家分享，并设置在线互动问答。',
    date: '2026-08-26',
    time: '14:00–16:00',
    location: '在线直播',
    format: '线上',
    status: '直播中',
    registered: 1268,
    attended: 986,
    agenda: [
      { time: '14:00', title: '开场与会议介绍', speaker: '大会主席' },
      { time: '14:10', title: '精准治疗循证进展', speaker: '陈教授 · 上海' },
      { time: '14:55', title: '临床病例讨论', speaker: '李教授 · 北京' },
      { time: '15:35', title: '在线答疑与总结', speaker: '专家组' },
    ],
  },
  {
    id: 'lung-mdt',
    title: '肺癌精准诊疗 MDT 云端论坛',
    therapy: '肺癌',
    summary: '聚焦肺癌精准诊疗路径，通过真实病例讨论关键检测、治疗选择与 MDT 协作要点。',
    date: '2026-09-05',
    time: '19:00–20:30',
    location: '在线会议',
    format: '线上',
    status: '报名中',
    registered: 516,
    agenda: [
      { time: '19:00', title: '开场与会议介绍', speaker: '大会主席' },
      { time: '19:10', title: '肺癌精准诊疗进展', speaker: '陈教授 · 上海' },
      { time: '19:45', title: 'MDT 病例讨论', speaker: '李教授 · 北京' },
      { time: '20:15', title: '在线答疑与总结', speaker: 'MDT 专家组' },
    ],
  },
]

export const kpis = [
  { label: '活跃 HCP', value: '24,680', change: '+12.6%', tone: 'blue' },
  { label: '内容阅读', value: '186,420', change: '+8.3%', tone: 'green' },
  { label: '任务完成', value: '18,536', change: '+15.2%', tone: 'purple' },
  { label: '反馈回流率', value: '98.8%', change: '+1.4%', tone: 'orange' },
] as const

export const adminUsers = [
  { name: '李医生', id: 'HCP-102846', hospital: '上海交通大学医学院附属医院', therapy: '乳腺癌', status: '已认证', active: '2 分钟前' },
  { name: '陈医生', id: 'HCP-102511', hospital: '复旦大学附属肿瘤医院', therapy: '肺癌', status: '已认证', active: '18 分钟前' },
  { name: '张医生', id: 'HCP-101938', hospital: '北京协和医院', therapy: '血液肿瘤', status: '待复核', active: '1 小时前' },
  { name: '王医生', id: 'HCP-101642', hospital: '中山大学肿瘤防治中心', therapy: '乳腺癌', status: '已认证', active: '昨天' },
  { name: '赵医生', id: 'HCP-100824', hospital: '四川大学华西医院', therapy: '胃肠道肿瘤', status: '已暂停', active: '7 天前' },
]
